export { default } from './createChainedFunction';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/createChainedFunction/index.js
// module id = 741
// module chunks = 22